/**
 * Created by liubaorui on 22/11/14.
 */

import axios from 'axios';
function generateReqKey(config) {
  const { method, url } = config;
  return [method, url ? url.split("?")[0] : ''].join("&");
}

const pendingRequest = new Map();
export const addPendingRequest = function (config) {
  const requestKey = generateReqKey(config);
  config.cancelToken = config.cancelToken || new axios.CancelToken((cancel) => {
    if (!pendingRequest.has(requestKey)) {
      pendingRequest.set(requestKey, cancel);
    }
  });
}
// 删除重复
export const removePendingRequest = function (config) {
  const requestKey = generateReqKey(config);
  if (pendingRequest.has(requestKey)) {
    const cancelToken = pendingRequest.get(requestKey);
    cancelToken(requestKey);
    pendingRequest.delete(requestKey);
  }
}